import { render } from "./CreateNominee.vue?vue&type=template&id=053131f8&scoped=true"
import script from "./CreateNominee.vue?vue&type=script&lang=js"
export * from "./CreateNominee.vue?vue&type=script&lang=js"

import "./CreateNominee.vue?vue&type=style&index=0&id=053131f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053131f8"]])

export default __exports__